import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { ProtocolService } from 'src/app/shared/services/API/risk-classification/protocol.service';


@Component({
  selector: 'app-protocol-delete-modal',
  templateUrl: './protocol-delete-modal.component.html',
  styleUrls: ['./protocol-delete-modal.component.css']
})
export class ProtocolDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<ProtocolDeleteModalComponent>,
    private protocolService: ProtocolService,
    private alertService: AlertService,
  ) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteProtocol: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.protocolService.DeleteProtocol(this.data.idProtocol).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Protocolo excluido com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteProtocol: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteProtocol: false}); 
  }
}